"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _consts = require("./../../consts.js");

var _OzRow = _interopRequireDefault(require("./../../OzRow/OzRow.js"));

var _OzCol = _interopRequireDefault(require("./../../OzCol/OzCol.js"));

var _OzCard = _interopRequireDefault(require("./../../OzCard/OzCard.js"));

var _OzButton = _interopRequireDefault(require("./../../OzButton/OzButton.js"));

var _OzTypo = _interopRequireDefault(require("./../../OzTypo/OzTypo.js"));

var __jsx = _react.default.createElement;

var FormSuccess = function FormSuccess(_ref) {
  var onConfirm = _ref.onConfirm;
  return __jsx(_OzCard.default, null, __jsx(_OzTypo.default, {
    variant: "h1c",
    color: _consts.CHETWODEBLUE
  }, "Success"), __jsx(_react.default.Fragment, null, "Well done."), __jsx(_OzRow.default, null, __jsx(_OzCol.default, {
    widthmd: "12"
  }, __jsx(_OzButton.default, {
    variant: "chetwodeblue",
    onClick: function onClick() {
      return onConfirm({
        action: "navigate",
        params: {
          page: "login"
        }
      });
    }
  }, "Sign in"))));
};

var _default = FormSuccess;
exports.default = _default;